export const paymentStatus = {
    WAITING: 0,
    IN_PROGRESS: 1,
    AUTHORIZED: 2,
    PAID: 3,
    CANCELLED_BY_USER: 4,
    FAILED: 5,
    ABANDONED: 6,
    WAITING_MANUAL_VALIDATION: 7,
    FAILED_REJECTED: 8,
};
